import { render, staticRenderFns } from "./DynamicUTable.vue?vue&type=template&id=392633f4&scoped=true&"
import script from "./DynamicUTable.vue?vue&type=script&lang=js&"
export * from "./DynamicUTable.vue?vue&type=script&lang=js&"
import style0 from "./DynamicUTable.vue?vue&type=style&index=0&id=392633f4&lang=css&scoped=true&"
import style1 from "./DynamicUTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392633f4",
  null
  
)

export default component.exports